import axios from "axios";
import Vue from "vue";
import { Message } from "element-ui";

const additionalProducts = {
  state: () => ({
    filter: {
      skip: 0,
      take: 1000000,
      searchTerm: null,
      ids: [],
      totalCount: 0,
      pendingRegistration: 0
    },
    participantFilter: {
      packetIds: [],
      registrationFormId: null,
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      checkIn: null,
      isCardPrinted: null,
      voucherSendStatus: null,
      voucherTaskStatus: null,
      voucherType: null,
      activationStatus: null,
      minimumCheckInDate: null,
      groupIDs: null,
      activationCode: null,
      paymentType: null,
      maximumCheckInDate: null,
      paymentStatus: null,
      promotionIDs: null,
      tagIDs: null,
      subEventIDs: null,
      couponCode: null,
      paymentID: null,
      minCardPrintDate: null,
      maxCardPrintDate: null,
      minCheckInDate: null,
      maxCheckInDate: null,
      checkInDateRange: null,
      cardDateRange: null,
      venueMinDate: null,
      venueMaxDate: null,
      venueDateRange: null,
      venueID: null,
      subEventRegistrationStatus: null,
      createDateRange: null,
      promotionIDs: [],
      createDateMaxDate: null,
      createDateMinDate: null,
      hasAdditionalProduct: true
    },
    participantFilterReset: {
      packetIds: [],
      registrationFormId: null,
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      checkIn: null,
      isCardPrinted: null,
      voucherSendStatus: null,
      voucherTaskStatus: null,
      voucherType: null,
      activationStatus: null,
      minimumCheckInDate: null,
      groupIDs: null,
      activationCode: null,
      paymentType: null,
      maximumCheckInDate: null,
      paymentStatus: null,
      promotionIDs: null,
      tagIDs: null,
      subEventIDs: null,
      couponCode: null,
      paymentID: null,
      minCardPrintDate: null,
      maxCardPrintDate: null,
      minCheckInDate: null,
      maxCheckInDate: null,
      checkInDateRange: null,
      cardDateRange: null,
      venueMinDate: null,
      venueMaxDate: null,
      venueDateRange: null,
      venueID: null,
      subEventRegistrationStatus: null,
      createDateRange: null,
      promotionIDs: [],
      createDateMaxDate: null,
      createDateMinDate: null,
      hasAdditionalProduct: true
    },
    recordItems: [],
    items: []
  }),
  mutations: {
    productRecordsFilterReset(state) {
      state.participantFilter = JSON.parse(JSON.stringify(state.participantFilterReset));
    },
    setAdditionalProductList(state, payload) {
      console.log('payloadSetList', payload);
      state.items = payload.items;
      state.filter.totalCount = payload.totalCount;
      var totalRecords = 0;
      state.items.map(x => {
        totalRecords += x.pending;
      });
      state.filter.pendingRegistration = totalRecords;
    },
    setProductRecords(state, payload) {
      state.recordItems = payload.items;
      state.participantFilter.total = payload.totalCount;
    }
  },
  actions: {
    async participantConfirmProduct(store, payload) {
      var res = await axios.post("participant/confirmadditionalproductregistration", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async participantCancelProduct(store, payload) {
      var res = await axios.post("participant/canceladditionalproductregistration", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getProductRecords(store) {
      await axios
        .post("participant/list", {
          ...store.state.participantFilter,
          skip: (store.state.participantFilter.page - 1) * store.state.participantFilter.take
        })
        .then(res => {
          return store.commit("setProductRecords", res.data.data);
        });
    },
    async addUpdateProduct(store, payload) {
      var res = await axios.post("/AdditionalProduct/addorupdate", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async deleteProduct(store, payload) {
      var res = await axios.post("AdditionalProduct/delete", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        store.dispatch("getProducts");
      }
      return res;
    },
    async getProducts(store) {
      var res = await axios.post("/AdditionalProduct/List", store.state.filter);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        store.commit("setAdditionalProductList", res.data.data);
      }
    },
    async getProductOne(store, payload) {
      var res = await axios.post("/AdditionalProduct/Get", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async toggleProductShow(store, payload) {
      var res = await axios.post("/AdditionalProduct/ToggleISActive", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async updateProductsOrder(store, payload) {
      var res = await axios.post("/AdditionalProduct/UpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {
    getProductRecords: state => state.recordItems,
    getProductRecordFilter: state => state.participantFilter,
    getProducts: state => state.items,
    getProductFilter: state => state.filter
  }
};

export default additionalProducts;



// WEBPACK FOOTER //
// ./src/store/additionalProducts.js